import React, { Component, createRef } from 'react';
import {
  trackAnalyticsChartType,
  trackAnalyticsFeature
} from '../../../../Telemetry/Mixpanel/Features/analyticsTracker';
import DownloadIcon from '../../../../Components/Buttons/DownloadIcon';
import { humanizeNumber } from '../../../../Utils/NumberUtils';
import PropTypes from 'prop-types';
import { PNG } from '../../../../Utils/Constants';
import {
  DOWNLOAD_VIEWS_CHART,
  MixpanelChartType,
  PNG as mixpanel_PNG,
  RECORDING_DETAILS,
  VALUE_ADD
} from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import moment from 'moment-timezone';
import applyExporting from 'highcharts/modules/exporting';
import applyOffline from 'highcharts/modules/offline-exporting';
import applyExportData from 'highcharts/modules/export-data';
import { buildMomentsBetweenDates, dateSorter } from '../../../../Utils/MomentUtils';
import './ViewsChart.css';
class ViewsChart extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool,
    fromTime: PropTypes.string.isRequired,
    toTime: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(
      PropTypes.shape({
        givenName: PropTypes.string,
        surName: PropTypes.string,
        email: PropTypes.string,
        lastWatchDate: PropTypes.string
      })
    ),
    user: PropTypes.object
  };
  constructor() {
    super();
    this.chartRef = createRef();
  }

  render() {
    return this.recordingChartComponent();
  }
  componentDidMount() {
    applyExporting(Highcharts);
    applyOffline(Highcharts);
    applyExportData(Highcharts);
  }

  recordingChartComponent = () => {
    const { t } = this.context;
    const { isBig, totalViewCount = 0, user } = this.props;

    return (
      <div className="viewsChart ">
        <div className="panelHeader">
          <div>
            <div className="panelTitleValue">{humanizeNumber(totalViewCount)}</div>
            <div className="panelTitle">{t('recordings.views')}</div>
          </div>
          <div>
            <div onClick={() => this.onClickHandler(PNG)}>
              <DownloadIcon />
            </div>
          </div>
        </div>
        <div className="panelBody">
          <HighchartsReact
            ref={this.chartRef}
            highcharts={Highcharts}
            constructorType={'chart'}
            options={this.getChartOptions(isBig, user)}
          />
        </div>
      </div>
    );
  };

  onClickHandler = id => {
    let type = MixpanelChartType.RECORDING_DETAILS_G2W_CHART;
    trackAnalyticsFeature(VALUE_ADD, RECORDING_DETAILS, DOWNLOAD_VIEWS_CHART);
    if (id === PNG) {
      this.chartRef.current.chart.exportChart();
      trackAnalyticsChartType(type, mixpanel_PNG);
    }
  };

  getChartOptions = (isBig, user) => {
    const { t } = this.context;
    const darkMode = user && user.darkMode;
    return {
      colors: ['#0c9ae7'],
      chart: {
        type: 'line',
        height: 220,
        zoomType: 'x',
        backgroundColor: darkMode ? '#444444' : '#ffffff'
      },
      legend: {
        enabled: false
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false,
        csv: {
          decimalPoint: null
        },
        type: 'image/png',
        url: 'https://export.highcharts.com/'
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%b %e',
          week: '%b %e'
        },
        tickWidth: 0,
        crosshair: {
          width: '1',
          color: '#b4b6c3',
          dashStyle: 'solid'
        },
        labels: {
          style: {
            color: darkMode ? '#ffffff' : '#666666'
          }
        }
      },
      yAxis: [
        {
          min: 0,
          title: '',
          tickAmount: 5,
          allowDecimals: false,
          labels: {
            style: {
              color: darkMode ? '#ffffff' : '#666666'
            }
          }
        }
      ],
      tooltip: isBig
        ? {
            useHTML: true,
            shared: true,
            formatter: ViewsChart.formatTooltip,
            borderRadius: '2',
            borderWidth: '0',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 15px 0 rgba(0, 0, 0, 0.08)',
            backgroundColor: darkMode ? '#2A2A2A' : '#ffffff',
            style: {
              color: darkMode ? '#ffffff' : '#444444',
              fontSize: '0.75em',
              fontFamily: 'Lato, sans-serif'
            }
          }
        : { enabled: false },
      plotOptions: {
        line: {
          marker: {
            enabled: false
          }
        }
      },
      series: [
        {
          name: t('recordings.views'),
          data: this.getChartData()
        }
      ]
    };
  };

  getChartData() {
    const { views = [], fromTime = null, toTime = null } = this.props;
    const { t } = this.context;
    const viewDates = views.map(view => view.viewDate, []).sort(dateSorter);
    if (viewDates.length === 0 || fromTime === null || toTime === null) {
      return [];
    }
    const viewCountMomentList = buildMomentsBetweenDates(
      moment(fromTime).startOf('day'),
      moment(toTime).endOf('day')
    ).map(momentDay => ({
      viewsString: t('tableHeaderColumns.views'),
      x: momentDay.valueOf(),
      y: 0,
      formattedDate: momentDay.format(t('formatting.dayDate'))
    }));

    viewDates.forEach(viewDate => {
      viewCountMomentList.forEach((viewMoment, index) => {
        if (moment(viewMoment.x).isSame(viewDate, 'day')) {
          viewCountMomentList[index] = { ...viewMoment, y: viewMoment.y + 1 };
          return true;
        }
      });
    });
    return viewCountMomentList;
  }

  static formatTooltip(tooltip, x = this.x, points = this.points) {
    let { formattedDate, y, viewsString } = points[0].point;
    return `<br/>
      <div style="font-size: 16px; font-weight: bold; font-style: normal; font-stretch: normal; line-height: 1;
      letter-spacing: normal; padding-bottom: 6px;">
        ${formattedDate}
      </div>
      <hr style="border-top: 1px solid #d0d2dd; margin-top: 11px; margin-bottom: 16px;" />
      <div style="display: flex; flex-direction: row; justify-content: space-between; padding-bottom: 16px;">
        <div style="font-size: 16px; font-weight: 500; font-style: normal; font-stretch: normal; line-height: normal;
        letter-spacing: normal;">${viewsString}</div>
        <div style="font-size: 16px; font-weight: 500; font-style: normal; font-stretch: normal; line-height: normal;
        letter-spacing: normal;">${y}</div>
      </div>
      `;
  }
}

export default ViewsChart;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/RecordingDetails/Chart/ViewsChart.js